import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import HTTP from '../../../../services/http';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
/**COMPONENTS */
import Loader from '../../../common/loader';
import ROW from './row';
import Modal from '../../../common/deleteModal';

import { ValidateOnlyAlpha } from '../../../common/fieldValidations';
import { HelpBlock, Table } from 'react-bootstrap';

var timer;
class TableComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array: [],
      isLoading: false,
      searchQuery: '',
      activePage: 1,
      totalItemsCount: 1,
      showModal: false,
    };
    /**event binding */
    this.getCachedPages = this.getCachedPages.bind(this);
    this.search = this.search.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
  }

  componentWillMount() {
    this.getCachedPages();
  }
  render() {
    const { array, isLoading, seracherror } = this.state;
    return (
      <div>
        {isLoading && <Loader />}

        <div className="portlet light bordered">
          <div className="portlet-body min-heigh">
            {/* actions search addnew  */}
            <div className="table-toolbar">
              <div className="row">
                {/* <!-- search --> */}
                <div className="col-md-2">
                  <div className="btn-group pull-right">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search url(s)"
                      onChange={this.search}
                      id="search_field"
                    />
                    <HelpBlock style={{ color: '#e73d4a' }}>
                      {seracherror ? seracherror : null}
                    </HelpBlock>
                  </div>
                </div>

                {/* <!-- add new --> */}
                <div className="col-md-1 col-sm-offset-9">
                  <div className="btn-group pull-right">
                    <button
                      id="sample_editable_1_new"
                      className="btn sbold red"
                      onClick={this.showDeleteModal}
                    >
                      Delete All
                    </button>
                    {this.state.showModal && <Modal show={true} func={this.deleteAll} closeParentModal={this.closeModal} /> }
                  </div>
                </div>

              </div>
            </div>
            {/* actions search addnew END */}

            {/* if list is empty */}
            {!isLoading && !array.length ? (
              <Alert bsStyle="warning">
                <strong>No Data Found !</strong>
              </Alert>
            ) : (
              <div style={{ display: 'flow-root' }}>
                <Table responsive striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th> Page URL </th>
                      <th width="15%"> Actions </th>
                    </tr>
                  </thead>

                  <tbody>
                    {array.map((cache) => {
                      return <ROW key={cache} page={cache}  delete={this.delete} />;
                    })}
                  </tbody>
                </Table>
                {/* <div style={{ float: 'right' }}>
                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={window.limit}
                    totalItemsCount={this.state.totalItemsCount}
                    pageRangeDisplayed={3}
                    onChange={this.handlePageChange}
                  />
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  /**PAGINATION */
  handlePageChange(eventKey) {
    this.setState({ activePage: eventKey });
    this.getCachedPages({
      page: eventKey ? eventKey : 1,
      search: this.state.searchQuery ? this.state.searchQuery : '',
    });
    /**to set query in route */
    this.props.history.push({
      search: '?page=' + eventKey,
    });
  }
  /**SEARCH */
  search(e) {
    /**to remove Event Pooling  */
    e.persist();
    let searchedValue = e.target.value;
    let seracherror = ValidateOnlyAlpha(searchedValue);
    if (seracherror) {
      this.setState({ seracherror: seracherror });
      return;
    }

        if (!searchedValue.length) {
            this.setState({ searchQuery: '', seracherror: '', activePage: 1 });
            this.props.history.push({
                search: '?page=' + 1
            });
        } else if (searchedValue.length > 2) {
            this.props.history.push({
            search: '?page=' + 1
        });
        this.setState({ searchQuery: searchedValue, activePage: 1, seracherror: seracherror });
        } else {
            this.setState({ seracherror: 'Enter minimum 3 characters to search.', searchQuery: '' });
            return;
        }
    
        clearTimeout(timer);
        timer = setTimeout(() => {
        this.getCachedPages({
            page: this.state.activePage ? this.state.activePage : 1,
            search: this.state.searchQuery
        });
        }, 1000);
    }

  /**to get list of roles */
  getCachedPages(params = {}) {
    /**to start Loader */
    this.setState({ isLoading: true });
    HTTP.Request('post', window.admin.getCachedPages, params).then((response) => {
      this.setState({
        array: response.data,
        isLoading: false,
        totalItemsCount: response.data.totalCount || 0,
      });
    });
  }

  delete(keyName){
    /**to start Loader */
    this.setState({ isLoading: true });

   HTTP.Request("delete", window.admin.deleteCachedPageKey, { keyName })
   .then(result => {
    this.getCachedPages({
      page: 1,
      search: this.state.searchQuery
    });
     toast(result.message,{type:"success"});
     this.setState({ isLoading: false });
   })
   .catch(err => {
      this.setState({ isLoading: false });
      toast(err.message, { type: "error" }) ;
    })
  }

  showDeleteModal() {
    this.setState({ showModal: true});
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  deleteAll(){
    /**to start Loader */
    this.setState({ isLoading: true });

   HTTP.Request("delete", window.admin.deleteAllCachedPages)
   .then(result => {
    this.getCachedPages({
      page: 1,
      search: this.state.searchQuery
    });
     toast(result.message,{type:"success"});
     this.setState({ isLoading: false, showModal: false });
   })
   .catch(err => {
      this.setState({ isLoading: false });
      toast(err.message, { type: "error", showModal: false }) ;
    })
  }
}

export default TableComp;
